export enum AppAction {
  logout = 'logout',
}
